/**
 * @file fileUpload.ts
 * @path apps/website/src/lib/fileUpload.ts
 * @description
 */

// File upload validation utilities for job applications

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
];

const ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx"];

export interface FileValidationResult {
  valid: boolean;
  error?: string;
}

export function validateCVFile(file: File): FileValidationResult {
  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    return {
      valid: false,
      error: `File size must be less than ${MAX_FILE_SIZE / 1024 / 1024}MB. Your file is ${(file.size / 1024 / 1024).toFixed(2)}MB.`,
    };
  }

  // Check file type
  const fileExtension = "." + file.name.split(".").pop()?.toLowerCase();
  const isValidType = ALLOWED_FILE_TYPES.includes(file.type);
  const isValidExtension = ALLOWED_EXTENSIONS.includes(fileExtension || "");

  if (!isValidType && !isValidExtension) {
    return {
      valid: false,
      error: "Please upload a PDF, DOC, or DOCX file.",
    };
  }

  return { valid: true };
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + " " + sizes[i];
}
